"use client";

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

interface AppUIContextType {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
}

const AppUIContext = createContext<AppUIContextType | undefined>(undefined);

export const AppUIProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window !== "undefined") {
      // Em mobile sempre começa fechado
      if (window.innerWidth < 992) {
        return false;
      }
      return true;
    }
    return false;
  });

  useEffect(() => {
    const handleResize = () => {
      // Em mobile sempre mantém fechado
      if (window.innerWidth < 992) {
        setSidebarOpen(false);
      } else {
        // Em desktop mantém aberto por padrão
        setSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    // Garante o estado correto no mount
    if (typeof window !== "undefined") {
      handleResize();
    }

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <AppUIContext.Provider value={{ sidebarOpen, toggleSidebar }}>
      {children}
    </AppUIContext.Provider>
  );
};

export const useAppUI = () => {
  const context = useContext(AppUIContext);
  if (context === undefined) {
    throw new Error("useAppUI must be used within an AppUIProvider");
  }
  return context;
};
